import { ChangeEvent, useEffect, useState } from 'react';
import { applyColorTheme } from '../../theme/brandColors';

type ColorSelectorProps = {
    colorVariable: string;
    defaultColor: string;
    label?: string;
    onColorChange?: (color: string) => void;
};

const parseColorVariable = (colorVariable: string): 'primary' | 'secondary' =>
  colorVariable.includes('secondary') ? 'secondary' : 'primary';

const ColorThemeSelector = ({ colorVariable, defaultColor, label, onColorChange }: ColorSelectorProps) => {
  const [selectedColor, setSelectedColor] = useState(defaultColor);

  useEffect(() => {
    setSelectedColor(defaultColor);
  }, [defaultColor]);

  const handleColorChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newColor = event.target.value;
    setSelectedColor(newColor);
    applyColorTheme(newColor, parseColorVariable(colorVariable));

    onColorChange && onColorChange(newColor);
  };

  return (
    <div className="max-w-full">
        <p>{ label }:</p>
        <input type="color" value={selectedColor} onChange={handleColorChange} />
    </div>
  );
};

export default ColorThemeSelector;
